import {NgModule} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {OverviewComponent} from './overview/overview.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {SharedModule} from "../../common/shared.module";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {ServerAvgComponent} from "./server-avg/server-avg.component";
import {UsageAvgComponent} from "./usage-avg/usage-avg.component";
import {OverviewCardComponent} from './overview-card/overview-card.component';
import {OverviewLogComponent} from './overview-log/overview-log.component';
import {OverviewNetworkCpuComponent} from './overview-network-cpu/overview-network-cpu.component';
import {ResourceAvgComponent} from './resource-avg/resource-avg.component';
import {NetworkInstancesComponent} from './network-instances/network-instances.component';
import {TranslocoModule} from "@ngneat/transloco";
import {SharedMiniModule} from "../../common/shared-mini.module";

import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HC_bullet from "highcharts/modules/bullet";
import HC_solid_gauge from "highcharts/modules/solid-gauge";

HighchartsMore(Highcharts);
HC_bullet(Highcharts);
HC_solid_gauge(Highcharts);

@NgModule({
    imports: [
        MatProgressSpinnerModule,
        FontAwesomeModule,
        SharedModule,
        SharedMiniModule,
        DragDropModule,
        TranslocoModule
    ],
    declarations: [
        OverviewComponent,
        ServerAvgComponent,
        UsageAvgComponent,
        OverviewCardComponent,
        OverviewLogComponent,
        OverviewNetworkCpuComponent,
        ResourceAvgComponent,
        NetworkInstancesComponent
    ],
    exports: [
        OverviewComponent,
        ServerAvgComponent,
        UsageAvgComponent,
        OverviewNetworkCpuComponent
    ]
})
export class OverviewModule {
}
